/**
 * Default backend origin when REACT_APP_BACKEND_URL is unset in local dev.
 * Keep in sync with scripts/start-dev.ps1 and scripts/restart-api.ps1 (uvicorn --port).
 */
export const DEV_BACKEND_BASE_URL = 'http://localhost:8010';
